import { CONSTANTS } from '../_data/constants.js';
import { EXTRUDED_PROFILE_SURFACE_BIAS } from '../_data/frameExtent.js';
import { panelSurfacePoint } from './curvedPanel.js';
export function buildSphereShape(args) {
    const { radius, widthSegments, heightSegments } = args;
    return {
        shapeKind: CONSTANTS.Enums.ShapeKind.sphere,
        labelHostCapability: 'above-only',
        radius,
        ...(widthSegments === undefined ? {} : { widthSegments }),
        ...(heightSegments === undefined ? {} : { heightSegments }),
        anchorsByKey: {
            center: { anchorKey: 'center', localPosition: [0, 0, 0] },
        },
    };
}
export function buildPanelShape(args) {
    const { width, height, depth } = args;
    return {
        shapeKind: CONSTANTS.Enums.ShapeKind.panel,
        labelHostCapability: 'above-and-on',
        width,
        height,
        ...(depth === undefined ? {} : { depth }),
        ...(args.curvatureRadius === undefined ? {} : { curvatureRadius: args.curvatureRadius }),
        anchorsByKey: {
            center: { anchorKey: 'center', localPosition: [0, 0, 0] },
            uMaxMid: { anchorKey: 'uMaxMid', localPosition: panelSurfacePoint(width / 2, 0, args.curvatureRadius) },
            vMaxMid: { anchorKey: 'vMaxMid', localPosition: [0, height / 2, 0] },
            uMinMid: { anchorKey: 'uMinMid', localPosition: panelSurfacePoint(-width / 2, 0, args.curvatureRadius) },
            vMinMid: { anchorKey: 'vMinMid', localPosition: [0, -height / 2, 0] },
        },
    };
}
export function buildCylinderWallShape(args) {
    return {
        shapeKind: CONSTANTS.Enums.ShapeKind.cylinderWall,
        labelHostCapability: 'above-only',
        ...args,
        anchorsByKey: {
            center: { anchorKey: 'center', localPosition: [0, 0, 0] },
        },
    };
}
export function buildExtrudedProfileShape(args) {
    return {
        shapeKind: CONSTANTS.Enums.ShapeKind.extrudedProfile,
        labelHostCapability: 'above-only',
        ...args,
        anchorsByKey: { center: { anchorKey: 'center', localPosition: [0, 0, 0] } },
    };
}
export function buildCubeShape(args) {
    const { side } = args;
    if (!Number.isFinite(side) || side <= 0)
        throw new Error('Cube side must be a finite positive number.');
    if (side < 0.0001)
        throw new Error('Cube side is below the renderer minimum of 0.0001.');
    // A square bar is a cube; compensate its surface bias to keep the center anchor centered.
    const z = -side / 2 - EXTRUDED_PROFILE_SURFACE_BIAS;
    return buildExtrudedProfileShape({
        profileKind: 'bar', from: [0, -side / 2, z], to: [0, side / 2, z],
        lateral: [1, 0, 0], innerWidth: side, lipThickness: 0, lipHeight: side, floorDepth: 0,
    });
}
/** Endpoints are resolved per-frame by the renderer, so they start collapsed at the origin. */
export function buildLineGuideShape(args) {
    const start = args?.start ?? [0, 0, 0];
    const end = args?.end ?? [0, 0, 0];
    return {
        shapeKind: CONSTANTS.Enums.ShapeKind.lineGuide,
        labelHostCapability: 'above-only',
        start,
        end,
        anchorsByKey: {
            start: { anchorKey: 'start', localPosition: [0, 0, 0] },
            mid: { anchorKey: 'mid', localPosition: [0, 0, 0] },
            end: { anchorKey: 'end', localPosition: [0, 0, 0] },
        },
    };
}
